export default {
  installationSection: {
    title: {
      fr: "Déploiement plug & play",
      en: "Plug & play deployment",
    },
    subtitle: {
      fr: "Une mise en service rapide et sans complexité.",
      en: "Fast and hassle-free commissioning.",
    },
    features: {
      title: {
        fr: "Une installation simplifiée",
        en: "Simplified installation",
      },
      items: {
        preProgram: {
          title: {
            fr: "AVANT INSTALLATION",
            en: "BEFORE INSTALLATION",
          },
          description: {
            fr: "Programmation sur table par un intégrateur.",
            en: "Pre-configuration performed off-site by the integrator.",
          },
        },
        minimiseCable: {
          title: {
            fr: "MINIMISEZ LE CÂBLAGE",
            en: "MINIMIZE CABLING",
          },
          description: {
            fr: "Grâce à une installation au plus proche des équipements à piloter.",
            en: "By installing devices as close as possible to the equipment being controlled.",
          },
        },
        noInternet: {
          title: {
            fr: "DÉPLOYEZ SANS INTERNET NI ROUTEUR",
            en: "DEPLOY WITHOUT INTERNET OR ROUTER",
          },
          description: {
            fr: "Dès la mise sous tension, tout est fonctionnel.",
            en: "Fully operational as soon as the system is powered on.",
          },
        },
      },
    },
  },
};
